"use client";

import { useEffect } from "react";

import { readDexSdk } from "../dex-sdk";
import {
  applySpotMids,
  SPOT_ASSET_CONTEXTS_QUERY_KEY,
  SpotAssetContextsByAddr,
} from "../queries/spot-asset-contexts";
import { useRegisterSubscription } from "../subscription-provider";

/**
 * Subscribes to the `all_spot_mids` topic and folds mid / last-trade updates
 * into the cached spot asset contexts, keeping the 24h stats from the HTTP
 * snapshot while the price fields stay live.
 */
export function useSpotMidsSubscription() {
  const registerSubscription = useRegisterSubscription();

  useEffect(() => {
    const queryKey = SPOT_ASSET_CONTEXTS_QUERY_KEY;

    const unregister = registerSubscription(queryKey, (queryClient) =>
      readDexSdk.marketPrices.subscribeAllSpotMids((data) => {
        queryClient.setQueryData<SpotAssetContextsByAddr>(queryKey, (prevData) => {
          if (!prevData) return prevData;
          return applySpotMids(prevData, data.mids);
        });
      }),
    );

    return unregister;
  }, [registerSubscription]);
}
